var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
// services
import { EventsService } from '../../core/services/events-service/events.service';
import { ProfileService } from '../../core/services/profile-service/profile.service';
// components
import { AlertComponent } from '../../shared';
// constants
import { tshirtSizes, scrollItType, getPhoneMask, stateList, } from '../../shared';
import { PrefillFormComponent } from '../prefill-form/prefill-form.component';
var refRoles = [
    'Corner Judge',
    'Center Referee',
    'Sport Poomsae Judge',
    'TechnicalAssistant',
];
var refCertForms = [
    'Non Certified',
    'AAU Certified',
    'USAT Level 1',
    'USAT Level 2',
    'WTF Poomsae IR',
    'CUTA Certified',
];
var refCertSparring = [
    'Non Certified',
    'AAU Certified',
    'CUTA Certified',
    'USAT D2',
    'USAT D1',
    'USAT C2',
    'USAT C1',
    'USAT B2',
    'USAT B1',
    'USAT A2',
    'USAT A1',
    'WTF IR (Kyorugi 3rd Class)',
    'WTF IR (Kyorugi 2nd Class)',
    'WTF IR (Kyorugi 1st Class)',
    'WTF IR (Kyorugi S Class)',
];
var RefereeRegistrationComponent = /** @class */ (function () {
    function RefereeRegistrationComponent(fb, calculateAge, scrollIt, eventService, route, profileService) {
        this.fb = fb;
        this.calculateAge = calculateAge;
        this.scrollIt = scrollIt;
        this.eventService = eventService;
        this.route = route;
        this.profileService = profileService;
        this.showValidation = false;
        this.eventId = '';
        this.successHtml = '';
        this.hasSelectedPrefill = false;
    }
    Object.defineProperty(RefereeRegistrationComponent.prototype, "shirtSizes", {
        get: function () {
            return tshirtSizes;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RefereeRegistrationComponent.prototype, "refRoles", {
        get: function () {
            return refRoles;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RefereeRegistrationComponent.prototype, "refCertForms", {
        get: function () {
            return refCertForms;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RefereeRegistrationComponent.prototype, "refCertSparring", {
        get: function () {
            return refCertSparring;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RefereeRegistrationComponent.prototype, "waiverText", {
        get: function () {
            return this.eventService.waiver.text;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RefereeRegistrationComponent.prototype, "waiverHeader", {
        get: function () {
            return this.eventService.waiver.header;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RefereeRegistrationComponent.prototype, "isClosed", {
        get: function () {
            return this.eventService.isRegistrationClosed('referee');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RefereeRegistrationComponent.prototype, "eventUrl", {
        get: function () {
            return this.eventService.eventData.url;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RefereeRegistrationComponent.prototype, "stateList", {
        get: function () {
            return stateList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RefereeRegistrationComponent.prototype, "profile", {
        get: function () {
            return this.profileService.profile;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RefereeRegistrationComponent.prototype, "isGuest", {
        get: function () {
            return this.profileService.isGuest;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RefereeRegistrationComponent.prototype, "schools", {
        get: function () {
            return this.eventService.schools;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RefereeRegistrationComponent.prototype, "membershipIdField", {
        get: function () {
            return this.eventService.eventData.registrations.referees.membership_id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RefereeRegistrationComponent.prototype, "roleRequired", {
        get: function () {
            return this.eventService.eventData.registrations.referees.role;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RefereeRegistrationComponent.prototype, "message", {
        get: function () {
            return this.eventService.eventData.registrations.referees.message;
        },
        enumerable: true,
        configurable: true
    });
    RefereeRegistrationComponent.prototype.getExtraFields = function () {
        var output = {};
        if (this.membershipIdField) {
            output.membership_id = [
                '',
                this.membershipIdField.required ? Validators.required : [],
            ];
        }
        if (this.roleRequired) {
            output.role = ['', Validators.required];
        }
        return output;
    };
    RefereeRegistrationComponent.prototype.ngOnInit = function () {
        this.initializeForm();
        this.getEventId();
    };
    RefereeRegistrationComponent.prototype.getEventId = function () {
        this.eventId = this.route.snapshot.parent.params.id;
    };
    RefereeRegistrationComponent.prototype.shirtSizeRequired = function () {
        if (this.eventService.eventData.registrations.referees.shirt) {
            return { shirt_size: ['', Validators.required] };
        }
        else {
            return {};
        }
    };
    RefereeRegistrationComponent.prototype.hotelRequired = function () {
        if (this.eventService.eventData.registrations.referees.hotel) {
            return { hotel: [false] };
        }
        else {
            return {};
        }
    };
    RefereeRegistrationComponent.prototype.initializeForm = function () {
        var _this = this;
        this.form = this.fb.group(__assign({ 
            // personal information
            name_first: ['', Validators.required], name_middle: [''], name_last: ['', Validators.required], birth_date: ['', Validators.required], gender: ['', Validators.required], 
            // contact information
            email: ['', [Validators.required, Validators.email]], phone: ['', Validators.required], address: ['', Validators.required], address_2: [''], city: ['', Validators.required], state: ['', Validators.required], zip: ['', Validators.required] }, this.shirtSizeRequired(), { school: this.fb.group({
                id: [''],
                name: [''],
                master: [''],
                address: [''],
                address_2: [''],
                city: [''],
                state: [''],
                zip: [''],
                country: [''],
                phone: [''],
                email: [''],
                url: [''],
            }, {
                validator: this.schoolRequired,
            }), cert_forms: ['', Validators.required], cert_sparring: ['', Validators.required] }, this.getExtraFields(), { 
            // parent information
            parent_name_first: [''], parent_name_middle: [''], parent_name_last: [''], parent_email: [''], parent_phone: [''] }, this.hotelRequired(), { subscription: [false], legal_age: [false, Validators.requiredTrue], no_crime: [false, Validators.requiredTrue], waiver: [false, Validators.requiredTrue], terms_and_conditions: [false, Validators.requiredTrue], catchall: [false, Validators.requiredTrue] }), {
            validator: function (control) { return _this.parentRequired(control); },
        });
        // console.log('adding mock data');
        // this.form.patchValue(mockData);
    };
    RefereeRegistrationComponent.prototype.schoolRequired = function (control) {
        var value = control.value;
        if (value.id === '') {
            return { required: true };
        }
        if (value.id !== '-1') {
            return null;
        }
        var schoolFields = [
            'id',
            'name',
            'master',
            'address',
            'city',
            'state',
            'zip',
            'phone',
        ];
        var output = {};
        schoolFields.forEach(function (field) {
            if (value[field] === '') {
                output[field] = { required: true };
            }
        });
        if (Object.keys(output).length > 0) {
            return output;
        }
        else {
            return null;
        }
    };
    RefereeRegistrationComponent.prototype.parentRequired = function (control) {
        var value = control.value;
        if (!this.form || !this.isMinor(this.form)) {
            return null;
        }
        var parentFields = [
            'parent_name_first',
            'parent_name_last',
            'parent_email',
            'parent_phone',
        ];
        var output = {};
        parentFields.forEach(function (field) {
            if (value[field] === '') {
                output[field] = { required: true };
            }
        });
        if (Object.keys(output).length > 0) {
            return output;
        }
        else {
            return null;
        }
    };
    RefereeRegistrationComponent.prototype.isMinor = function (formGroup) {
        var birth_date = formGroup.get('birth_date').value;
        return this.calculateAge(new Date(birth_date)) < 18;
    };
    RefereeRegistrationComponent.prototype.onSubmit = function () {
        var _this = this;
        this.scrollIt(0);
        if (this.form.invalid) {
            this.alert.newAlert('Please fill out required fields', 'danger');
            this.showValidation = true;
            return;
        }
        this.alert.newAlert('Submitting...', 'info');
        this.eventService.postReferee(this.eventId, this.form.value).subscribe(function (res) {
            if (res && res._html_message) {
                _this.successHtml = res._html_message;
            }
            else {
                _this.alert.newAlert('There was an error', 'danger');
            }
            // TODO - add type to res
            // this.alert.newAlert('Success', 'Form has been submitted!', 'success');
        }, function (err) {
            // TODO - handle?
            _this.alert.newAlert('There was an error', 'danger');
        });
    };
    RefereeRegistrationComponent.prototype.resetForm = function () {
        this.form.reset();
        this.successHtml = '';
        this.showValidation = false;
        this.hasSelectedPrefill = false;
    };
    RefereeRegistrationComponent.prototype.openModal = function (event, modalName) {
        event.preventDefault();
        switch (modalName) {
            case 'waiver':
                this.waiverModal.open();
                break;
            case 'terms':
                this.termsModal.open();
                break;
            default:
                break;
        }
    };
    RefereeRegistrationComponent.prototype.getPhoneMask = function (formControl) {
        return getPhoneMask(this.form.get(formControl).value);
    };
    return RefereeRegistrationComponent;
}());
export { RefereeRegistrationComponent };
